// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '099f2789-89fa-4f4b-8da3-10bd94bc0be3',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '14a318c3-96db-45fc-b2f4-4e531a4d9ed8',
      type: 'Sprite',
      name: 'rays',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.275,
        y: 0.275
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3'
    },
    {
      id: '8090c987-0c6b-4a9c-b66a-140114a46139',
      type: 'Container',
      name: 'sparkleParticlesSlot',
      className: '',
      x: 1,
      y: 44,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3'
    },
    {
      id: 'e15d5fbf-50ba-4dd9-9a96-6e4ff71be48d',
      type: 'Container',
      name: 'progressBarSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3'
    },
    {
      id: 'd9205719-0c93-4230-a110-d6027e736061',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Shadow_Overlay',
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3'
    },
    {
      id: '591a68ab-f00c-40c0-8850-ab9239382ecd',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Top',
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3'
    },
    {
      id: '0389e6c0-cd5e-4f57-ad1b-b558c0cc1a35',
      type: 'Container',
      name: 'pigSlot',
      className: '',
      x: 12,
      y: -26,
      scale: {
        x: 0.58,
        y: 0.58
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3',
      stateByName: {
        'in-progress': {
          y: -26,
          x: 12
        },
        full: {
          x: 12,
          y: -26
        },
        'in-progress_tier': {
          y: -26,
          x: 12
        },
        full_tier: {
          y: -33,
          x: 12
        }
      }
    },
    {
      id: 'b6b26657-c969-4e98-8265-5df50acbe953',
      type: 'Sprite',
      name: 'coinContainer',
      className: '',
      x: 0,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Counter',
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3',
      stateByName: {
        full: {
          texture: 'Main_Menu_Icon_Counter_Full',
          visible: true
        },
        'in-progress_tier': {
          visible: false
        },
        full_tier: {
          visible: false
        },
        'in-progress': {
          visible: true
        }
      }
    },
    {
      id: '06e8f614-181b-4b2e-9dd3-5a1524ea08e8',
      type: 'Sprite',
      name: 'timerContainer',
      className: '',
      x: 0,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Counter',
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3',
      stateByName: {
        full: {
          texture: 'Main_Menu_Icon_Counter_Full',
          visible: false
        },
        'in-progress': {
          visible: false
        },
        full_tier: {
          visible: true,
          y: 60
        },
        'in-progress_tier': {
          y: 50,
          visible: true
        }
      }
    },
    {
      id: '32b81ef5-71ce-4bd0-901e-e01b59fba449',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Main_Menu_Icon_Full_Background',
      parent: '099f2789-89fa-4f4b-8da3-10bd94bc0be3',
      stateByName: {
        full_tier: {
          visible: true,
          y: 28
        },
        full: {
          visible: false
        },
        'in-progress_tier': {
          visible: false
        },
        'in-progress': {
          visible: false
        }
      }
    },
    {
      id: '87fc055a-25ed-49cf-b965-a425f85af951',
      type: 'Text',
      name: 'piggyBankCounter',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.55
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3000/3000',
      localize: false,
      maxWidth: 85,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#6F1F0C',
        stroke: '#ffffff',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: '#007fff',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b6b26657-c969-4e98-8265-5df50acbe953',
      stateByName: {
        full: {
          text: 'Full',
          localize: true,
          style: {
            stroke: '#A73151',
            fill: '#ffffff',
            strokeThickness: 5
          }
        }
      }
    },
    {
      id: '1b93a597-92c1-420a-9096-e70a10f1dcc2',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.55
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'XXd YYh',
      localize: false,
      maxWidth: 85,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#6F1F0C',
        stroke: '#ffffff',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: '#007fff',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '06e8f614-181b-4b2e-9dd3-5a1524ea08e8',
      stateByName: {
        full: {
          text: 'Full',
          localize: true,
          style: {
            stroke: '#A73151',
            fill: '#ffffff',
            strokeThickness: 5
          }
        }
      }
    },
    {
      id: 'd8063c7b-fa0b-43d5-876e-e4ea0fdb9bee',
      type: 'Text',
      name: '',
      className: 'upperCase_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Full',
      localize: true,
      maxWidth: 85,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#FFFFFF',
        stroke: '#A73151',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: '#007fff',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '32b81ef5-71ce-4bd0-901e-e01b59fba449',
      stateByName: {
        full: {
          text: 'Full',
          localize: true,
          style: {
            stroke: '#A73151',
            fill: '#ffffff',
            strokeThickness: 5
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'in-progress',
    'full',
    'in-progress_tier',
    'full_tier'
  ],
  handleResize: false
} as const;

export class PiggyBankIconLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  rays!: Sprite;
  sparkleParticlesSlot!: Container;
  progressBarSlot!: Container;
  pigSlot!: Container;
  coinContainer!: Sprite;
  timerContainer!: Sprite;
  piggyBankCounter!: Text;
  timerText!: Text;
  upperCase_SPL!: (Text)[];
  StateName!: 'in-progress' | 'full' | 'in-progress_tier' | 'full_tier';

  constructor() {
    populate(this, raw);
  }
}
